// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Formality = require("@tan/formality/src/Formality.bs.js");
let Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let SystemMessage = require("../common/Components/SystemMessage.bs.js");
let SystemMessages = require("../../reason/systemMessages/SystemMessages.bs.js");
let Form__TextInput = require("../common/Components/Form__TextInput.bs.js");
let Form__Components = require("../../reason/common/Form/Form__Components.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let MobileInputTextSize = require("../common/Form/MobileInputTextSize.bs.js");
let Formality__ReactUpdate = require("@tan/formality/src/Formality__ReactUpdate.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let FormalityCompat__PublicHelpers = require("@tan/formality/src/FormalityCompat__PublicHelpers.bs.js");
let PasswordSettings_ChangeCurrentUserPasswordMutation_graphql = require("../../__generated__/PasswordSettings_ChangeCurrentUserPasswordMutation_graphql.bs.js");

let validators_currentPassword = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let pw = Form__Helpers.noneIfEmpty(param.currentPassword);
    if (pw !== undefined) {
      return {
        TAG: "Ok",
        _0: pw
      };
    } else {
      return {
        TAG: "Error",
        _0: "is required"
      };
    }
  }
};

let validators_newPassword = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let pw = Form__Helpers.noneIfEmpty(param.newPassword);
    if (pw !== undefined) {
      if (pw.length < 8) {
        return {
          TAG: "Error",
          _0: "Must be at least 8 characters"
        };
      } else {
        return {
          TAG: "Ok",
          _0: pw
        };
      }
    } else {
      return {
        TAG: "Error",
        _0: "is required"
      };
    }
  }
};

let validators_confirmPassword = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let confirmPassword = param.confirmPassword;
    let match = Form__Helpers.noneIfEmpty(param.newPassword);
    let match$1 = Form__Helpers.noneIfEmpty(confirmPassword);
    if (match !== undefined) {
      if (match$1 !== undefined && match === match$1) {
        return {
          TAG: "Ok",
          _0: confirmPassword
        };
      } else {
        return {
          TAG: "Error",
          _0: "Passwords must match"
        };
      }
    } else {
      return {
        TAG: "Error",
        _0: ""
      };
    }
  }
};

let validators = {
  currentPassword: validators_currentPassword,
  newPassword: validators_newPassword,
  confirmPassword: validators_confirmPassword
};

function initialFieldsStatuses(input) {
  return {
    currentPassword: "Pristine",
    newPassword: "Pristine",
    confirmPassword: "Pristine"
  };
}

function initialFieldStatuses_xxx(x) {
  return {
    currentPassword: "Pristine",
    newPassword: "Pristine",
    confirmPassword: "Pristine"
  };
}

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: {
      currentPassword: "Pristine",
      newPassword: "Pristine",
      confirmPassword: "Pristine"
    },
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, validators, fieldsStatuses) {
  let match = fieldsStatuses.currentPassword;
  let tmp;
  tmp = typeof match !== "object" ? validators.currentPassword.validate(input) : match._0;
  let match$1 = fieldsStatuses.newPassword;
  let tmp$1;
  tmp$1 = typeof match$1 !== "object" ? validators.newPassword.validate(input) : match$1._0;
  let match$2 = fieldsStatuses.confirmPassword;
  let tmp$2;
  tmp$2 = typeof match$2 !== "object" ? validators.confirmPassword.validate(input) : match$2._0;
  let currentPasswordResult = tmp;
  let currentPasswordResult$1;
  if (currentPasswordResult.TAG === "Ok") {
    let newPasswordResult = tmp$1;
    if (newPasswordResult.TAG === "Ok") {
      let confirmPasswordResult = tmp$2;
      if (confirmPasswordResult.TAG === "Ok") {
        return {
          TAG: "Valid",
          output: {
            currentPassword: currentPasswordResult._0,
            newPassword: newPasswordResult._0,
            confirmPassword: confirmPasswordResult._0
          },
          fieldsStatuses: {
            currentPassword: {
              TAG: "Dirty",
              _0: currentPasswordResult,
              _1: "Shown"
            },
            newPassword: {
              TAG: "Dirty",
              _0: newPasswordResult,
              _1: "Shown"
            },
            confirmPassword: {
              TAG: "Dirty",
              _0: confirmPasswordResult,
              _1: "Shown"
            }
          },
          collectionsStatuses: undefined
        };
      }
      currentPasswordResult$1 = currentPasswordResult;
    } else {
      currentPasswordResult$1 = currentPasswordResult;
    }
  } else {
    currentPasswordResult$1 = currentPasswordResult;
  }
  return {
    TAG: "Invalid",
    fieldsStatuses: {
      currentPassword: {
        TAG: "Dirty",
        _0: currentPasswordResult$1,
        _1: "Shown"
      },
      newPassword: {
        TAG: "Dirty",
        _0: tmp$1,
        _1: "Shown"
      },
      confirmPassword: {
        TAG: "Dirty",
        _0: tmp$2,
        _1: "Shown"
      }
    },
    collectionsStatuses: undefined
  };
}

function useForm(initialInput, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurCurrentPasswordField" :
          let result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.currentPassword, validators_currentPassword, status => {
            let init = state.fieldsStatuses;
            return {
              currentPassword: status,
              newPassword: init.newPassword,
              confirmPassword: init.confirmPassword
            };
          });
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurNewPasswordField" :
          let result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.newPassword, validators_newPassword, status => {
            let init = state.fieldsStatuses;
            return {
              currentPassword: init.currentPassword,
              newPassword: status,
              confirmPassword: init.confirmPassword
            };
          });
          if (result$1 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$1,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurConfirmPasswordField" :
          let result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.confirmPassword, validators_confirmPassword, status => {
            let init = state.fieldsStatuses;
            return {
              currentPassword: init.currentPassword,
              newPassword: init.newPassword,
              confirmPassword: status
            };
          });
          if (result$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$2,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let match$1 = validateForm(state.input, validators, state.fieldsStatuses);
          if (match$1.TAG !== "Valid") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: match$1.fieldsStatuses,
                collectionsStatuses: match$1.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: "AttemptedToSubmit"
              }
            };
          }
          let output = match$1.output;
          let error = state.formStatus;
          let tmp;
          tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : error._0;
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              input: state.input,
              fieldsStatuses: match$1.fieldsStatuses,
              collectionsStatuses: match$1.collectionsStatuses,
              formStatus: {
                TAG: "Submitting",
                _0: tmp
              },
              submissionStatus: "AttemptedToSubmit"
            },
            _1: param => {
              let dispatch = param.dispatch;
              onSubmit(output, {
                notifyOnSuccess: input => dispatch({
                  TAG: "SetSubmittedStatus",
                  _0: input
                }),
                notifyOnFailure: error => dispatch({
                  TAG: "SetSubmissionFailedStatus",
                  _0: error
                }),
                reset: () => dispatch("Reset"),
                dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
              });
            }
          };
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateCurrentPasswordField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.currentPassword, state.submissionStatus, validators_currentPassword, status => {
                let init = state.fieldsStatuses;
                return {
                  currentPassword: status,
                  newPassword: init.newPassword,
                  confirmPassword: init.confirmPassword
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateNewPasswordField" :
          let nextInput$1 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$1,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.newPassword, state.submissionStatus, validators_newPassword, status => {
                let init = state.fieldsStatuses;
                return {
                  currentPassword: init.currentPassword,
                  newPassword: status,
                  confirmPassword: init.confirmPassword
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateConfirmPasswordField" :
          let nextInput$2 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$2,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.confirmPassword, state.submissionStatus, validators_confirmPassword, status => {
                let init = state.fieldsStatuses;
                return {
                  currentPassword: init.currentPassword,
                  newPassword: init.newPassword,
                  confirmPassword: status
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: {
                  currentPassword: "Pristine",
                  newPassword: "Pristine",
                  confirmPassword: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: {
                  currentPassword: "Pristine",
                  newPassword: "Pristine",
                  confirmPassword: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: map(error$2)
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateCurrentPassword: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateCurrentPasswordField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateNewPassword: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateNewPasswordField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateConfirmPassword: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateConfirmPasswordField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurCurrentPassword: () => dispatch("BlurCurrentPasswordField"),
    blurNewPassword: () => dispatch("BlurNewPasswordField"),
    blurConfirmPassword: () => dispatch("BlurConfirmPasswordField"),
    currentPasswordResult: Formality.exposeFieldResult(state.fieldsStatuses.currentPassword),
    newPasswordResult: Formality.exposeFieldResult(state.fieldsStatuses.newPassword),
    confirmPasswordResult: Formality.exposeFieldResult(state.fieldsStatuses.confirmPassword),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.currentPassword;
      if (typeof tmp === "object") {
        return true;
      }
      let tmp$1 = match.newPassword;
      if (typeof tmp$1 === "object") {
        return true;
      }
      let tmp$2 = match.confirmPassword;
      return typeof tmp$2 === "object";
    },
    valid: () => {
      let match = validateForm(state.input, validators, state.fieldsStatuses);
      return match.TAG === "Valid";
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let FormConfig = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

let genericErrorMessage = "We encountered a problem when trying to update your password. Please contact support if the problem persists.";

let convertVariables = PasswordSettings_ChangeCurrentUserPasswordMutation_graphql.Internal.convertVariables;

let convertResponse = PasswordSettings_ChangeCurrentUserPasswordMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = PasswordSettings_ChangeCurrentUserPasswordMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, PasswordSettings_ChangeCurrentUserPasswordMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, PasswordSettings_ChangeCurrentUserPasswordMutation_graphql.node, convertResponse, convertWrapRawResponse);

let ChangeCurrentUserPasswordMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function PasswordSettings(props) {
  let match = use();
  let changePassword = match[0];
  let match$1 = SystemMessages.useSystemMessages();
  let addMessage = match$1.addMessage;
  let form = useForm({
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
  }, (param, param$1) => {
    let reset = param$1.reset;
    let notifyOnFailure = param$1.notifyOnFailure;
    let notifyOnSuccess = param$1.notifyOnSuccess;
    changePassword({
      input: {
        currentPassword: param.currentPassword,
        newPassword: param.newPassword
      }
    }, undefined, undefined, undefined, (response, param) => {
      let match = response.changeCurrentUserPassword;
      if (match === undefined) {
        return notifyOnFailure(genericErrorMessage);
      }
      switch (match.__typename) {
        case "CurrentUserPasswordChanged" :
          addMessage(SystemMessages.Message.make(undefined, "success", "Password updated", 15000, undefined, undefined));
          notifyOnSuccess(undefined);
          return reset();
        case "InvalidCurrentPasswordError" :
          return notifyOnFailure("The current password you typed is incorrect. Please check it and try again.");
        case "__unselected" :
          return notifyOnFailure(genericErrorMessage);
      }
    }, undefined, undefined);
  });
  let error = form.status;
  let tmp;
  tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? null : JsxRuntime.jsx(SystemMessage.make, {
      id: "form_submitted",
      time: 5000,
      text: error._0,
      type_: "error",
      dismissible: true,
      secondary: true,
      handleOnDismiss: _id => form.dismissSubmissionResult()
    });
  let match$2 = form.currentPasswordResult;
  let tmp$1;
  tmp$1 = match$2 !== undefined && match$2.TAG !== "Ok" ? ({
      NAME: "Error",
      VAL: match$2._0
    }) : undefined;
  let match$3 = form.newPasswordResult;
  let tmp$2;
  tmp$2 = match$3 !== undefined && match$3.TAG !== "Ok" ? ({
      NAME: "Error",
      VAL: match$3._0
    }) : undefined;
  let match$4 = form.confirmPasswordResult;
  let tmp$3;
  tmp$3 = match$4 !== undefined && match$4.TAG !== "Ok" ? ({
      NAME: "Error",
      VAL: match$4._0
    }) : undefined;
  let tmp$4 = true;
  if (form.valid()) {
    let match$5 = form.status;
    let tmp$5;
    tmp$5 = typeof match$5 !== "object" ? match$5 !== "Editing" : match$5.TAG === "Submitting";
    tmp$4 = tmp$5;
  }
  return JsxRuntime.jsx("form", {
    children: JsxRuntime.jsxs("div", {
      children: [
        tmp,
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Form__TextInput.make, {
              labelText: "Current password",
              type: "password",
              onChange: event => form.updateCurrentPassword((v, value) => ({
                currentPassword: value,
                newPassword: v.newPassword,
                confirmPassword: v.confirmPassword
              }), event.target.value),
              onBlur: param => form.blurCurrentPassword(),
              disabled: form.submitting,
              status: Stdlib_Option.map(form.currentPasswordResult, x => {
                if (x.TAG === "Ok") {
                  return "ok";
                } else {
                  return "error";
                }
              }),
              value: form.input.currentPassword
            }),
            JsxRuntime.jsx(Form__Components.FieldError.make, {
              valid: tmp$1
            })
          ]
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Form__TextInput.make, {
              labelText: "New password",
              type: "password",
              placeholderText: "Must be at least 8 characters",
              onChange: event => form.updateNewPassword((v, value) => ({
                currentPassword: v.currentPassword,
                newPassword: value,
                confirmPassword: v.confirmPassword
              }), event.target.value),
              onBlur: param => form.blurNewPassword(),
              disabled: form.submitting,
              status: Stdlib_Option.map(form.newPasswordResult, x => {
                if (x.TAG === "Ok") {
                  return "ok";
                } else {
                  return "error";
                }
              }),
              value: form.input.newPassword
            }),
            JsxRuntime.jsx(Form__Components.FieldError.make, {
              valid: tmp$2
            })
          ]
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Form__TextInput.make, {
              labelText: "Confirm password",
              type: "password",
              onChange: event => form.updateConfirmPassword((v, value) => ({
                currentPassword: v.currentPassword,
                newPassword: v.newPassword,
                confirmPassword: value
              }), event.target.value),
              onBlur: param => form.blurConfirmPassword(),
              disabled: form.submitting,
              status: Stdlib_Option.map(form.confirmPasswordResult, x => {
                if (x.TAG === "Ok") {
                  return "ok";
                } else {
                  return "error";
                }
              }),
              value: form.input.confirmPassword
            }),
            JsxRuntime.jsx(Form__Components.FieldError.make, {
              valid: tmp$3
            })
          ]
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
            disabled: tmp$4,
            children: "Save"
          })
        })
      ],
      className: "flex max-w-md flex-col gap-4"
    }),
    className: MobileInputTextSize.className,
    onSubmit: extra => FormalityCompat__PublicHelpers.Dom.preventDefault(form.submit, extra)
  });
}

let make = PasswordSettings;

exports.FormConfig = FormConfig;
exports.genericErrorMessage = genericErrorMessage;
exports.ChangeCurrentUserPasswordMutation = ChangeCurrentUserPasswordMutation;
exports.make = make;
/* commitMutation Not a pure module */
